<template>
  <button
    :class="buttonClass"
    @click="send()"
  >
    <img
      src="/img/facebook_icon.svg"
      alt=""
    >

    <span v-if="buttonText">{{ buttonText }}</span>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    iconClass: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    buttonClass: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },

  methods: {
    send() {
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + this.url,
        "facebook-share-dialog",
        "width=626,height=436",
        "_blank"
      );
    }
  }
};
</script>
